module.exports = __webpack_public_path__ + "img/center-details-data3.cd30e8eb.png";